import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavMenu from './NavMenu';
import Logo from '../images/logo.png';
import Image from '../controls/Image';
import { selectors } from '../store/modules/User';

const Layout = (props) => {
  const {
    children, email, id, phone,
  } = props;

  return (
    <React.Fragment>
      <div id="gaas-sidebar" className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
        <div className="gaas-sidebar-logo">
          <Image src={Logo} alt="logo" />
        </div>
        {id && (
          <div id="gaas-sidebar-user">
            <div>
              {email}
              <br />
              <span style={{ fontSize: '80%' }}>{phone}</span>
            </div>
          </div>
        )}
        <hr />
        <hr />
        <NavMenu />
      </div>

      <div id="gaas-content" className="col-lg-10 col-md-10 col-sm-10 col-xs-12">
        <div id="content">
          <div id="content-loader">{children}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.element.isRequired,
  email: PropTypes.string,
  phone: PropTypes.string,
  id: PropTypes.string,
};

Layout.defaultProps = {
  email: null,
  id: null,
  phone: null,
};

export default connect(state => ({ ...state.user.auth, isAdmin: selectors.getIsAdmin(state) }))(Layout);



// WEBPACK FOOTER //
// ./src/containers/Layout.jsx